import { getConsent, isConsentStale } from "@/lib/consent-store";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Sent only after an analytics grant. The server ignores it while the flag is off. */
export function analyticsVisitorFields():
  | { analyticsGrant: true; visitorUuid: string }
  | Record<string, never> {
  const consent = getConsent();
  if (!consent?.visitorUuid || consent.grants.analytics !== true || isConsentStale(consent)) {
    return {};
  }
  if (!UUID_RE.test(consent.visitorUuid)) return {};
  return { analyticsGrant: true, visitorUuid: consent.visitorUuid };
}

/** Email links identify a contact with contactId, contact, or cid. */
export function contactIdFromSearch(search: string): string | undefined {
  const params = new URLSearchParams(search);
  const raw = params.get("contactId") ?? params.get("contact") ?? params.get("cid");
  if (!raw || !UUID_RE.test(raw)) return undefined;
  return raw;
}
